import { render, staticRenderFns } from "./PartyArchDiagram.vue?vue&type=template&id=4b808072&scoped=true"
import script from "./PartyArchDiagram.vue?vue&type=script&lang=js"
export * from "./PartyArchDiagram.vue?vue&type=script&lang=js"
import style0 from "./PartyArchDiagram.vue?vue&type=style&index=0&id=4b808072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b808072",
  null
  
)

export default component.exports